import {svgInfoTwLogo} from '../SvgCode'

export default class infoTW{
    constructor(_wrapper: HTMLElement) {
        this.templ(_wrapper);
    }

    templ(_parent: HTMLElement){

        _parent.classList.add('footer-info-tw');
        _parent.innerHTML= `
        <div class="info-inner">
            <span class="info-img">${svgInfoTwLogo}</span>
            <p class="info-text">
            本遊戲情節涉及角色穿著表達輕微性暗示、暴力、恐怖。<br>
            本遊戲部分內容或服務需另行支付其他費用，應避免過度消費。<br>
            注意使用時間，避免沉迷於遊戲，可能影響身心健康。
            </p>
        </div>	
        `;
    }
}